import { ValidationFunction, IValidity, Patterns } from "component-library";

export const validateAmountOfSplitValues =
  (
    allowedAmount: number,
    message: string,
    allowedAmountTemplate: string = "{allowedAmount}",
    separator: string = ","
  ): ValidationFunction =>
  (value: string): IValidity => {
    const validity: IValidity = {
      invalid: false,
      validationMessage: "",
    };

    const values = value
      .split(separator)
      .map((item) => item.trim())
      .filter((item) => Boolean(item));

    if (values.length > allowedAmount) {
      validity.invalid = true;
      validity.validationMessage = message.replace(
        allowedAmountTemplate,
        allowedAmount.toString()
      );
    }

    return validity;
  };

export const validateSplitStringItemsLength =
  (
    maxLength: number,
    message: string,
    emailTemplate: string = "{email}",
    maxLengthTemplate: string = "{maxLength}",
    separator: string = ","
  ): ValidationFunction =>
  (value: string): IValidity => {
    const validity: IValidity = {
      invalid: false,
      validationMessage: "",
    };

    const values = value
      .split(separator)
      .map((item) => item.trim())
      .filter((item) => Boolean(item));

    for (const item of values) {
      if (item.length > maxLength) {
        validity.invalid = true;
        validity.validationMessage = message
          .replace(emailTemplate, item)
          .replace(maxLengthTemplate, maxLength.toString());

        break;
      }
    }

    return validity;
  };

export const validateSplitStringOfEmails =
  (
    message: string,
    emailTemplate: string = "{email}",
    separator: string = ","
  ): ValidationFunction =>
  (value: string): IValidity => {
    const validity: IValidity = {
      invalid: false,
      validationMessage: "",
    };

    const values = value
      .split(separator)
      .map((item) => item.trim())
      .filter((item) => Boolean(item));

    for (const item of values) {
      if (!Patterns.email.test(item)) {
        validity.invalid = true;
        validity.validationMessage = message.replace(emailTemplate, item);

        break;
      }
    }

    return validity;
  };
